import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss']
})
export class VerificationComponent implements OnInit {

  certificationID: string;
  userId: string;
  isCertified: boolean = false;
  certificateData: any = null;
  currentYear: number = new Date().getFullYear();

  constructor(private route: ActivatedRoute, private commonservice: CommonService
    
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.certificationID = params['certificationID'];
      this.userId = params['userId'];
    });

    const obj = {
      certificateId: this.certificationID,
      userId: this.userId
    }
    this.verifyUserCetified(obj);
  }



verifyUserCetified(data: any){
  this.commonservice.getUserCertificate(data).subscribe((result: any) => {
    if (result?.success && result?.data && result?.data.length > 0) {
      this.isCertified = true;
      this.certificateData = result.data[0];
    } else {
      this.isCertified = false;
    }
  });
}

}
